export const currentEnvironmentSelector = (state) => state.EnvironmentReducer.currentEnvironment